import { Component, Inject, OnInit } from "@angular/core";
import { AsyncPipe, NgIf, NgFor } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogContent,
  MatDialogActions,
  MatDialogModule,
} from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatCard } from "@angular/material/card";

@Component({
  selector: "app-terms-page-view",
  standalone: true,
  imports: [
    MatDialogContent,
    MatDialogActions,
    NgIf,
    MatButtonModule,
    MatDialogModule,
    MatIconModule,
    MatCard,
  ],
  templateUrl: "./terms-page-view.component.html",
  styleUrls: ["./terms-page-view.component.css"],
})
export class TermsPageViewComponent implements OnInit {
  //public dialogRef = Inject(MatDialogRef<TermsPageViewComponent>);

  constructor(
    private dialogRef: MatDialogRef<TermsPageViewComponent> // Inject MatDialogRef here
  ) {}

  async ngOnInit() {
    // Initialization logic here
  }

  public saving = true;
  public loading = false;

  onCancel() {
    this.dialogRef.close({ saved: true });
  }
}
